let scrollTimeout

export default {
  install(Vue) {
    Vue.directive('scroll-to-me', {
      mounted: function (el) {
        clearTimeout(scrollTimeout)
        scrollTimeout = setTimeout(() => {
          el.scrollIntoView(true)
        }, 200)
      }
    })
  }
}
